<template>
	<c-input-element
		:label="label"
		class="c-form-element--datepicker"
		:class="{ 'c-form-element--horizontal' : horizontal }"
		:name="name"
	>
		<input 
			type="text"
			ref="input"
			:class="{'calendar-icon' : icon}"
			class="c-form-element--medium"
			:required="required"
			:disabled="disabled"
			:name="name"
			:data-datepicker-ref="uid" />
	</c-input-element>
</template>

<script>
import Input from '@mixins/Input';
import Filters from '@support/Filters';
import Helpers from '@support/Helpers';
import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js"

export default {
	mixins: [Input],
	inheritAttrs: false,
	props: {
		name: {
			type: String,
			required: true
		},
		icon: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			required: false,
			default: false
		},
		type: {
			type: String,
			default: '' //future of history
		},
		minDate: {
			type: Date,
		},
		maxDate: {
			type: Date
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			flatpickr: null,
			altInput: null,
			uid: ''
		}
	},
	watch: {
		modelValue(value) {
			this.set(value);
		},
		disabled(value) {
			this.altInput.disabled = value;
		}
	},
	methods: {
		set(date) {
			if ( date !== '' ) {
				this.flatpickr.setDate(date);
			}
			else {
				this.flatpickr.clear();
			}
		}
	},
	mounted() {
        this.uid = Helpers.uid();
        let options = {
            locale: Dutch,
			allowInvalidPreload: true,
            altInput: true,
            altFormat: 'd-m-Y',
            dateFormat: 'Y-m-d',
            onChange: (selectedDates, dateStr, instance) => {
                this.$emit('update:modelValue', this.$filter.datestring(selectedDates[0]));
                
                this.$nextTick( () => {
                    let ev = document.createEvent('Event');
                    ev.initEvent('datepicker.select', true, false);

                    this.$refs.input.dispatchEvent(ev);
                    this.altInput.dispatchEvent(ev);
                });

            },
            onReady: (dateObj, dateStr, fp) => {
                this.altInput = fp.altInput;

                fp.altInput.attr = false;
                fp.altInput.setAttribute('data-validator-trigger', 'datepicker.select');
                fp.altInput.setAttribute('data-datepicker-alt-ref', this.uid);

                Object.keys(this.$attrs).forEach( (attr) => {
                    fp.altInput.setAttribute(attr, this.$attrs[attr]);
                });
            }
        };

        if ( this.type == 'future' ) {
            // options.minDate = "today";
            options.minDate = new Date();
            options.minDate.setDate(options.minDate.getDate());
            options.minDate.setHours(0,0,0,0);
        }
        else if ( this.type == 'history' ) {
            options.maxDate = new Date();
            options.maxDate.setDate(options.maxDate.getDate() - 1);
            options.maxDate.setHours(23,59,59,0);
        }
        
        if ( this.minDate ) {
            options.minDate = this.minDate;
        }

        if ( this.maxDate ) {
            options.maxDate = this.maxDate;
        }        

        this.flatpickr = flatpickr(this.$refs.input, options);

        if ( this.modelValue !== '' ){
            this.set(this.modelValue);
        }
    }
}
</script>
